import { Component, Input } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { CountryService } from 'src/app/_services/country.service';
import { SnackbarService } from 'src/app/_services/snackBar.service';
import { SnackBarErrorComponent } from 'src/app/components/snack-bar-error/snack-bar-error.component';
import { ParentService } from 'src/app/user-management/_services/parent.service';
import { ModalConfig } from '../modal-config';
import { environment } from 'src/environments/environment';
import { ErrorMsgService } from '../../error-msg/error-msg.service';
import { DataService } from 'src/app/dashboard/_services/data.service';
import { ModalService } from '../modal.service';

@Component({
  selector: 'app-assign-assistant',
  templateUrl: './assign-assistant.component.html',
  styleUrls: ['./assign-assistant.component.scss']
})
export class AssignAssistantComponent {
  @Input() lang: string;
  @Input() config!: ModalConfig;

  countries = [];
  assignAssistantForm: UntypedFormGroup;
  assistantExistsInSystem: boolean = false;
  baseUrl = environment.img_url;
  loading:boolean = false;

  showedNumber:number;


  constructor(
    private _snackBar: MatSnackBar,
    private parentService: ParentService,
    private snackbarService: SnackbarService,
    private countryService: CountryService,
    private translate: TranslateService,
    private errorMsgService: ErrorMsgService,
    private dataService: DataService,
    private modalService:ModalService
  ) { }

  ngOnInit() {    
    this.initFormFields();
    this.getCountries();
    this.dataService.getRowsNumberShown().subscribe(res => {
      this.showedNumber = res
    })
  }


  initFormFields() {
    this.assignAssistantForm = new UntypedFormGroup({
      name: new UntypedFormControl('', [Validators.required]),
      national_id: new UntypedFormControl('', [Validators.required, Validators.pattern('[a-zA-Z0-9]*')]),
      gender: new UntypedFormControl('' , Validators.required),
      country_code: new UntypedFormControl('', Validators.required),
      phone: new UntypedFormControl('', [Validators.required]),
      email: new UntypedFormControl('', [Validators.email, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$')])
    })
  }

  getCountries() {
    this.countries = this.countryService.countries;
  }

  searchById() {
    if (this.assignAssistantForm.value.national_id !== '') {
      this.loading = true;
      this.parentService.searchByUserId(this.assignAssistantForm.value.national_id).subscribe((res: any) => {
        console.log('searchParentById', res);
        this.assistantExistsInSystem = true;
        this.assignAssistantForm.controls.name.setValue(res.name);
        this.assignAssistantForm.controls.national_id.setValue(res.national_id);
        this.assignAssistantForm.controls.gender.setValue(res.gender ? res.gender : 'male');
        this.assignAssistantForm.controls.country_code.setValue(res.country_code);
        this.assignAssistantForm.controls.phone.setValue(res.phone);
        this.assignAssistantForm.controls.email.setValue(res.email);
        this.loading = false;
      },
        (error) => {
          this.assistantExistsInSystem = false;
          this.snackbarService.setSnackBarMessage(error.error.message);
          this._snackBar.openFromComponent(SnackBarErrorComponent, {
            duration: 5000,
            horizontalPosition: 'center',
            verticalPosition: 'top',
          });
          this.loading = false;
        })
    }
    else {
      this.assignAssistantForm.controls.national_id.markAsTouched();
    }
  }

  getSerachByIdLabel() {
    let label = this.lang === 'en' ? 'Check Assistant ID' : 'تحقق من رقم الهوية للمساعد';
    return label;
  }
  // validation function for parent form
  getAssistantFormValidation(control: string) {
    let errorMSG;
    if (this.assignAssistantForm.controls[control].errors) {
      switch (control) {
        case 'name':
          errorMSG = this.assignAssistantForm.controls[control].errors.required ? this.translate.instant('edit-assistant.name-required') :
            this.assignAssistantForm.controls[control].errors.repeat ? this.translate.instant('edit-assistant.name-exists')
              : this.translate.instant('edit-assistant.name-valid');
          break;
        case 'national_id':
          errorMSG = this.assignAssistantForm.controls[control].errors.required ? this.translate.instant('edit-assistant.id-required') :
            this.assignAssistantForm.controls[control].errors.repeat ? this.translate.instant('edit-assistant.id-exists')
              : this.translate.instant('edit-assistant.id-valid');
          break;

        case 'phone':
          errorMSG = this.assignAssistantForm.controls[control].errors.required ? this.translate.instant('edit-assistant.phone-required') :
            this.assignAssistantForm.controls[control].errors.repeat ? this.translate.instant('edit-assistant.phone-exists')
              : this.translate.instant('edit-assistant.phone-valid');
          break;

        case 'email':
          errorMSG = this.assignAssistantForm.controls[control].errors.required ? this.translate.instant('edit-assistant.email-required') :
            this.assignAssistantForm.controls[control].errors.repeat ? this.translate.instant('edit-assistant.email-exists')
              : this.translate.instant('edit-assistant.email-valid');
          break;
        default:
          break;
      }
    }
    return errorMSG;
  }

  getIDErrorMessage() {
    let errorMSG;
    if (this.assignAssistantForm.controls.national_id.errors) {
      errorMSG = this.assignAssistantForm.controls.national_id.errors.required ?
        this.translate.instant('user-management.error-msgs.national-id-required') :
        // this.assignAssistantForm.controls.national_id.errors.pattern ?
        this.translate.instant('user-management.error-msgs.national-id-notValid');
      // 'National ID is not found'
    }
    return errorMSG;
  }

  saveAssistant(){
    const formData = new FormData();
    let assistant_info = { ...this.assignAssistantForm.value };
    for (const i in assistant_info) {
      formData.append(i, assistant_info[i])
    }
    formData.append('type' , 'helper')
    this.parentService.assignAssistantToStudent(this.config?.data?.id , formData).subscribe({
      next: () => {
        this.closeModalHandler();
      },
      error: (err) => {
        this.errorMsgService.setMessage(err?.error?.message);
      }
    });
  }

  closeModalHandler(){
    this.dataService.setRowsNumberShown(this.showedNumber);
    this.modalService.closeModal();
  }
}
